import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

    :root {
        --min-color: #3B4162;
        --min-color-rgba: 59, 65, 98;
        --sec-color: #DB7B86;
        --sec-color-rgba: 219, 123, 134;
        --txt-color: #CBCEEF;
    }

    * {
        font-family: "DroidArabicKufiRegular";
        
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        touch-action: manipulation;
        ::-webkit-scrollbar {
            display: none;
        }
    }
   

    .App {
        font-weight: normal;
        font-style: normal;
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: var(--txt-color);
    }

    a {
        text-decoration: none;
        color: var(--txt-color)
    }

    h2 {
        font-size: 16px;
    }

`;
export default GlobalStyle;
